import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isPhone, isWeb, Popup } from '@helpers';
import { font } from '@styles/fonts';
import Calendar from '@components/common/Calendar';
import TouchableElement from '@components/common/touchableElement';
import { formatDateToView } from './helpers';
import { useManageUtilizationHeader } from '@components/machines/components/Utilization/components/chart/hooks/useManageUtilizationHeader';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import Skeleton from '@v2/elements/Skeleton';

const HEADER_NUMBER_SKELETON = { width: scale(86), borderRadius: scale(6) };

export default ({ item: { date }, C, machineStatistics, machineStatisticsLoading, machineStatisticsIsError, setSelectedChartDate, selectedChartDate }) => {
  const { selectedTime, oeeInt, oeeDec, teepInt, teepDec, effectiveness } = useManageUtilizationHeader({
    machineStatistics,
    machineStatisticsLoading,
    machineStatisticsIsError,
  });

  const showCalendar = () => {
    Popup({
      Component: (p) => <Calendar {...{ ...p, C, setSelectedChartDate, selectedChartDate }} />,
      avoidingViewEnable: false,
    });
  };

  return (
    <View testID={TEST_IDS.utilizationHeader.container} style={{ width: '100%', paddingHorizontal: scale(15), marginBottom: scale(6) }}>
      <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
        <View testID={TEST_IDS.utilizationHeader.oeeColumn} style={{ flex: 1 }}>
          <View>
            <Text style={[font['Button 2'], { color: C('OEE/Light/OEE Chart') }]}>{i18n.t('OEE')}</Text>
          </View>
          {machineStatisticsLoading ? (
            <Skeleton C={C} {...HEADER_NUMBER_SKELETON} height={font['Large Title'].lineHeight} />
          ) : (
            <View>
              <View style={{ flexDirection: 'row', alignItems: 'baseline' }}>
                <Text style={[font['Large Title'], { color: C('OEE/Light/OEE Chart') }]}>{oeeInt}</Text>
                {oeeDec && (
                  <Text style={[font['Large Title'], { color: C('OEE/Light/OEE Chart') }]}>
                    ,{oeeDec}
                  </Text>
                )}
                <Text style={[font['Button 1'], { color: C('OEE/Light/OEE Chart'), marginTop: scale(isWeb ? 16 : 11) }]}>%</Text>
                {!isPhone && effectiveness && (
                  <Text testID={TEST_IDS.utilizationHeader.effectiveness} style={[font['Button 2'], { color: C(effectiveness.color), marginLeft: scale(6) }]}>
                    {effectiveness.label}
                  </Text>
                )}
              </View>
              {isPhone && effectiveness && (
                <Text testID={TEST_IDS.utilizationHeader.effectiveness} style={[font['Button 2'], { color: C(effectiveness.color) }]}>
                  {effectiveness.label}
                </Text>
              )}
            </View>
          )}
        </View>
        <View testID={TEST_IDS.utilizationHeader.teepColumn} style={{ flex: 1 }}>
          <View>
            <Text style={[font['Button 2'], { color: C('OEE/Light/TEEP') }]}>{i18n.t('Net Utilization')}</Text>
          </View>
          {machineStatisticsLoading ? (
            <Skeleton C={C} {...HEADER_NUMBER_SKELETON} height={font['Large Title'].lineHeight} />
          ) : (
            <View style={{ flexDirection: 'row' }}>
              <Text style={[font['Large Title'], { color: C('OEE/Light/TEEP') }]}>{teepInt}</Text>
              {teepDec && (
                <Text style={[font['Large Title'], { color: C('OEE/Light/TEEP') }]}>
                  ,{teepDec}
                </Text>
              )}
              <Text style={[font['Button 1'], { color: C('OEE/Light/TEEP'), marginTop: scale(isWeb ? 16 : 11) }]}>%</Text>
            </View>
          )}
        </View>
      </View>
      <TouchableElement testID={TEST_IDS.utilizationHeader.dateText} onPress={showCalendar} style={{ opacity: date ? 1 : 0, alignSelf: 'flex-start' }}>
        {({ boxStyle }) => (
          <View style={boxStyle}>
            <Text style={[font['Subhead 1'], { color: C('Label/Light/Quaternary'), fontVariant: ['tabular-nums'] }]}>{formatDateToView(date, selectedTime)}</Text>
          </View>
        )}
      </TouchableElement>
    </View>
  );
};
